import { API } from '../config/api';
import { DataService } from '../config/dataService/dataService';
import { ImportCustomersDataService } from '../config/dataService/importCustomersDataService';

class CompaniesService {
  static async getAll({ search, idServiceType, page, isServiceCreation, idHeadquarter }) {
    const queryParams = {
      search,
      idServiceType,
      page,
      isServiceCreation: Boolean(isServiceCreation),
      idHeadquarter,
    };
    const { data } = await DataService.get(API.companies.root, queryParams);
    return {
      companies: data.companies,
      page: data.page,
      total: data.total,
      pageSize: data.pageSize,
    };
  }

  static async getById(id) {
    const { data } = await DataService.get(API.companies.root + id);
    return data.company;
  }

  static async createCompany(companyData) {
    const bodyParams = {
      nit: companyData.nit,
      name: companyData.name,
      phone: companyData.phone,
      address: companyData.address,
      mainContactName: companyData.mainContactName,
      email: companyData.email,
      legalName: companyData.legalName,
      email2: companyData.email2,
    };
    const { data } = await DataService.post(API.companies.root, bodyParams);
    return {
      company: data.company,
      defaultContact: data.defaultContact,
    };
  }

  static async updateCompany(id, companyData) {
    const updateData = {
      nit: companyData.nit,
      name: companyData.name,
      phone: companyData.phone,
      address: companyData.address,
      legalName: companyData.legalName,
      email: companyData.email,
      servicesTypes: companyData.servicesTypes,
      isUsingAllServiceType: companyData.isUsingAllServiceType,
    };
    const { data } = await DataService.patch(API.companies.root + id, updateData);
    return {
      company: data.company,
      defaultContact: data.defaultContact,
    };
  }

  static async removeCompany({ idCompany }) {
    const { data } = await DataService.delete(`${API.companies.root}/${idCompany}`);
    return data;
  }

  static async getAllContacts({ search, idCompany, page }) {
    const { data } = await DataService.get(`${API.companies.root}/${idCompany}/${API.companies.contacts}/`, {
      search,
      page,
    });
    return {
      contacts: data.contacts,
      pageSize: data.pageSize,
      total: data.total,
    };
  }

  static async getContactById({ idContact, idCompany }) {
    const { data } = await DataService.get(`${API.companies.root}/${idCompany}/${API.companies.contacts}/${idContact}`);
    return data.contact;
  }

  static async createContact({ idCompany, contactData }) {
    const body = {
      name: contactData.name,
      reference: contactData.reference,
      address: contactData.address,
      markerCoords: contactData.markerCoords,
      identification: contactData.identification,
      phone: contactData.phone,
      email: contactData.email,
      note: contactData.note,
      emailNotifications: contactData.emailNotifications,
    };
    const { data } = await DataService.post(`${API.companies.root}/${idCompany}/${API.companies.contacts}/`, body);
    return data.contact;
  }

  static async updateContact({ idCompany, contactData, idContact }) {
    const body = {
      name: contactData.name,
      reference: contactData.reference,
      address: contactData.address,
      markerCoords: contactData.markerCoords,
      identification: contactData.identification,
      phone: contactData.phone,
      email: contactData.email,
      note: contactData.note,
      emailNotifications: contactData.emailNotifications,
    };
    const { data } = await DataService.patch(
      `${API.companies.root}/${idCompany}/${API.companies.contacts}/${idContact}`,
      body,
    );
    return data.contact;
  }

  static async removeContact({ customerId, contactId }) {
    const { data } = await DataService.delete(
      `${API.companies.root}${customerId}/${API.companies.contacts}/${contactId}`,
    );
    return data.contact;
  }

  static async getVariables(idCustomer) {
    const { data } = await DataService.get(`${API.companies.root}/${idCustomer}/${API.companies.variables}`);
    return data;
  }

  static async createVariable(companyId, values) {
    const { data } = await DataService.post(`${API.companies.root}${companyId}/${API.companies.variables}/`, values);
    return data;
  }

  static async editVariable(companyId, idVariable, values) {
    const { data } = await DataService.patch(
      `${API.companies.root}${companyId}/${API.companies.variables}/${idVariable}`,
      values,
    );
    return data;
  }

  static async deleteVariable(companyId, idVariable) {
    const { data } = await DataService.delete(
      `${API.companies.root}${companyId}/${API.companies.variables}/${idVariable}`,
    );
    return data;
  }

  static async getServiceTypeAssignations({ idCompany }) {
    const { data } = await DataService.get(
      `${API.companies.root}/${idCompany}/${API.companies.serviceTypeAssignations}`,
    );
    return {
      isUsingAllServiceType: data.isUsingAllServiceType,
      serviceTypes: data.serviceTypes,
    };
  }

  static async saveServiceTypeAssignations({ idCompany, isUsingAllServiceType, serviceTypesIds }) {
    const params = {
      isUsingAllServiceType: isUsingAllServiceType ?? false,
      serviceTypesIds: serviceTypesIds ?? [],
    };
    const { data } = await DataService.post(
      `${API.companies.root}/${idCompany}/${API.companies.serviceTypeAssignations}`,
      params,
    );
    return {
      isUsingAllServiceType: data.isUsingAllServiceType,
      serviceTypesIds: data.serviceTypesIds,
    };
  }

  static async validateCustomers({ file, idAccount }) {
    const params = {
      'customers.csv': file,
      idAccount,
    }
    const { data } = await ImportCustomersDataService.sendFile(`${API.importData.customers}/${API.importData.validateCustomer}`,
      params);
    return {
      data
    }
  }

  static async importCustomers({ idAccount, list }) {
    const params = {
      idAccount,
      list,
    }
    const { data } = await ImportCustomersDataService.post(`${API.importData.customers}/${API.importData.saveCustomers}`,
      params
    );
    return {
      data
    }
  }

}

export { CompaniesService };
